import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { accessoryAddToCart, accessoryUpdateQuantity } from '../Thunks/CartThunks';
import Spinner from '/Foundation/Common/code/Views/Foundation/Common/Spinner';

const AccessoryAddToCartButton = React.forwardRef(({ accessory, isSellable }, ref) => {
  const dispatch = useDispatch();
  const cartState = useSelector((state) => state.Cart);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const onClickAddToCart = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    if (!accessory?.productId) return;

    let lineItems = cartState.lineItems?.length > 0 ? cartState.lineItems : window._THULEDATA.cartLineItems;
    const productExistsInCart = lineItems?.find((item) => item.key === accessory.productId && !item.isFreeGift);
    let result;

    if (productExistsInCart) {
      let lineItemId = productExistsInCart.id;
      let lineItemQty = productExistsInCart.quantity + 1;
      result = await dispatch(accessoryUpdateQuantity({ id: lineItemId, quantity: lineItemQty }));
    } else {
      result = await dispatch(accessoryAddToCart(accessory.erpOutdoor));
    }
    ref.current.scrollTop = 0;
    setIsLoading(false);
    if (result.payload) {
      setIsSuccess(true);
      setTimeout(() => {
        setIsSuccess(false);
      }, [3000]);
    }
  };

  const getPrice = () => {
    return accessory.priceContainer?.discountPrice > 0
      ? accessory.priceContainer?.discountPrice
      : accessory.priceContainer?.price;
  };

  return (
    <>
      <button
        className="btn btn-sm thule-btn-default accessory-atc-button tag-manager-add-to-cart-button"
        aria-label={`${accessory.addToCartButton?.sellableButtonText ?? ''} ${accessory.webTitle1 ?? ''}`.trim()}
        disabled={!isSellable}
        onClick={(e) => {
          onClickAddToCart(e);
        }}
        data-product-id={accessory.productId}
      >
        {isLoading ? (
          <Spinner />
        ) : (
          <>{isSuccess ? <i className="le-icon-check" /> : <i className="le-icon-shopping-cart"></i>}</>
        )}
      </button>
      <input
        type="hidden"
        className="analyticsData"
        data-productid={accessory.productId}
        data-originalprice={accessory.priceContainer?.price}
        data-price={getPrice()}
        data-thuleproductname={accessory.productName}
        data-colorspecification={accessory.colorSpecification}
        data-overcategory={accessory.overCategory}
        data-category={accessory.category}
        data-subcategory={accessory.subcategory}
        data-isbundle={accessory.addToCartButton?.isBundle}
      />
      <span
        className="hidden analytics-data"
        data-name={accessory.webTitle1}
        data-pimid={accessory.productId}
        data-price={accessory.priceContainer?.priceFormatted}
      />
    </>
  );
});

export default AccessoryAddToCartButton;
